import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import * as fromBase from '../reducers'
import * as menus from '../actions/menus.actions'
import * as user from '../../auth/actions/user'
import { Action, select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, share, switchMap, take, withLatestFrom } from 'rxjs/operators';
import { withPredicateFrom } from '../../core/helpers/rx-pipes';
import * as fromAuth from '../../auth/reducers';
import { MenusService } from '../services/menus.service';

@Injectable()
export class MenusEffects {
  constructor(private actions$: Actions,
              private menusSvc: MenusService,
              private store: Store<fromBase.State>) {
  }

  @Effect()
  initMenus$: Observable<Action> =
    this.actions$.ofType<menus.Init>(menus.INIT)
      .pipe(
        withLatestFrom(
          this.store.pipe(select(fromBase.isMenusTtlExpired)),
          (action, isMenusTtlExpired) => ({ forceRefresh: action.forceRefresh, isMenusTtlExpired: isMenusTtlExpired })
        ),
        switchMap((data) => {
          let actionsArr = []
          if (data.forceRefresh || data.isMenusTtlExpired) {
            actionsArr.push(new menus.Get())
          } else {
            actionsArr.push(new menus.GetSkipped())
          }

          return of(...actionsArr)
        })
      )

  @Effect()
  getMenuItems$: Observable<Action> =
    this.actions$
      .pipe(
        ofType<menus.Get>(menus.GET),
        withPredicateFrom(
          this.store
            .pipe(
              select(fromAuth.isCustomerSelected)
            )
        ),
        withLatestFrom(
          this.store.pipe(select(fromAuth.getCustomerId)),
          (state, customerId) => customerId
        ),
        switchMap(customerId => {
          return this.menusSvc.getMenusEntities(customerId)
            .pipe(
              map(res => new menus.GetSuccess(res)),
              catchError(e => of(new menus.GetFailed(e)))
            )
        })
      )

  @Effect()
  getItemsOnLogin$: Observable<Action> =
    this.actions$
      .pipe(
        ofType<user.GetSuccess>(user.GET_SUCCESS),
        withPredicateFrom(
          this.store
            .pipe(
              select(fromAuth.isCustomerSelected)
            )
        ),
        map(_ => new menus.Init(true)),
        share()
      )

  @Effect()
  getOnLangChange$: Observable<Action> =
    this.actions$
      .pipe(
        ofType<user.SetLanguage>(user.SET_LANGUAGE),
        switchMap(() =>
          this.actions$
            .ofType<user.SetSuccess>(user.SET_SUCCESS)
            .pipe(
              take(1)
            )
        ),
        map(_ => new menus.Init(true))
      )
}
